import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, TextTooltip } from "@transfr-inc/dashboard-components";
import {
  ActivityUploadStatuses,
  getActivityUploadStatusDescription,
  getActivityUploadStatusDisplayName,
} from "@views/library/constants/activity-upload-status.model";
import React, { useEffect, useMemo, useState } from "react";

import "./status-badge.scss";
import UploadErrorsModal from "@views/library/modals/upload-errors.modal";

const StatusBadge = ({ activityData }) => {
  const { id, status, error } = activityData;

  const [showUploadErrorsModal, setShowUploadErrorsModal] = useState(false);

  const errorBadge = (
    <div onClick={() => setShowUploadErrorsModal(true)}>
      <Badge
        value={
          <>
            <FontAwesomeIcon icon={["fa-solid", "triangle-exclamation"]} />
            View Error
          </>
        }
        className="badge error"
      />
    </div>
  );

  const successBadge = (
    <Badge
      value={
        <>
          <FontAwesomeIcon icon={["fa-solid", "circle-check"]} />
          Success
        </>
      }
      className="badge success"
    />
  );

  const otherBadge = (
    <TextTooltip text={getActivityUploadStatusDescription(status)}>
      <Badge
        value={
          <>
            <FontAwesomeIcon icon={["fa-solid", "circle-info"]} />
            {getActivityUploadStatusDisplayName(status)}
          </>
        }
        className="badge other"
      />
    </TextTooltip>
  );

  const loadingSkeleton = (
    <div
      className="badge skeleton"
      style={{
        display: "inline-block",
        width: 96,
        height: 20,
        borderRadius: 4,
        background: "linear-gradient(90deg, #eee 25%, #f5f5f5 37%, #eee 63%)",
        backgroundSize: "400% 100%",
        animation: "syncBadgeSkeleton 1.4s ease infinite",
      }}
    />
  );

  const errorState = useMemo(() => {
    const errorExists = error && error.length > 0;
    return (
      errorExists ||
      status === ActivityUploadStatuses.FAILED_ZIP_UPLOAD.name ||
      status === ActivityUploadStatuses.FAILED_UNZIP_PROCESSING.name
    );
  }, [status, error]);

  const uploadInfo = useMemo(() => {
    if (errorState) {
      return errorBadge;
    }

    const isInSuccessState =
      status === ActivityUploadStatuses.COMPLETED_UNZIP.name;
    if (isInSuccessState) {
      return successBadge;
    }

    return otherBadge;
  }, [
    errorState,
    status,
    errorBadge,
    successBadge,
    otherBadge,
    loadingSkeleton,
  ]);

  return (
    <div className="upload-status-badge">
      {uploadInfo}
      <UploadErrorsModal
        open={showUploadErrorsModal}
        onClose={() => setShowUploadErrorsModal(false)}
        error={error}
        status={status}
      />
    </div>
  );
};

export default StatusBadge;
